import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["neighborhoodSection", "categorySection", "typeButton"]

  declare neighborhoodSectionTarget: HTMLElement
  declare categorySectionTarget: HTMLElement
  declare typeButtonTargets: HTMLElement[]

  select(event: Event) {
    const button = event.currentTarget as HTMLElement
    const type = button.dataset.tipType

    // Update button styles
    this.typeButtonTargets.forEach((btn) => {
      if (btn.dataset.tipType === type) {
        btn.classList.remove("bg-gray-100", "text-gray-700")
        btn.classList.add("bg-blue-600", "text-white")
      } else {
        btn.classList.remove("bg-blue-600", "text-white")
        btn.classList.add("bg-gray-100", "text-gray-700")
      }
    })

    // Show/hide sections and clear unchecked section
    if (type === "neighborhood") {
      this.neighborhoodSectionTarget.classList.remove("hidden")
      this.categorySectionTarget.classList.add("hidden")
      this.clearCheckboxes(this.categorySectionTarget)
    } else {
      this.categorySectionTarget.classList.remove("hidden")
      this.neighborhoodSectionTarget.classList.add("hidden")
      this.clearCheckboxes(this.neighborhoodSectionTarget)
    }

    // Update hidden tip_type field
    const hiddenField = this.element.querySelector<HTMLInputElement>('input[name="tip[tip_type]"]')
    if (hiddenField) hiddenField.value = type!
  }

  private clearCheckboxes(section: HTMLElement) {
    section.querySelectorAll<HTMLInputElement>('input[type="checkbox"]').forEach((cb) => {
      cb.checked = false
    })
  }
}
